export const employeeRegex = /employee\d/gi;
export const precedentIdRegex = /{{P-(.*?)}}/;
export const htmlRegex = /<[a-z/][\s\S]*>/;
export const emailRegex = /^[^.](?!.*\.\.)([\w\+'.-]+)(?<!\.)@([\w.-]+)[^.]$/;
export const fileExtension = /\.[^\/.]+$/;
